import React from "react";
import { useIntl } from "react-intl";

import { Field } from "src/common/components/Field";
import { UnknownInputRenderer } from "src/features/forms/components/UnknownInputRenderer";
import { NodeContextProvider } from "src/features/forms/context/NodeContext";
import { useError, useRequired } from "src/features/forms/hooks/useField";
import { FieldData, InputData } from "src/features/forms/types";

export const FieldRenderer: React.FunctionComponent<FieldData> = React.memo(
	props => (
		<NodeContextProvider path={props.path}>
			<ContentRenderer {...props} />
		</NodeContextProvider>
	)
);

const ContentRenderer: React.FunctionComponent<FieldData> = ({
	label: labelMsg,
	help: helpMsg,
	errorMessages,
	input,
	path
}) => {
	const { formatMessage } = useIntl();
	const required = useRequired();
	const error = useError(errorMessages);
	return (
		<Field
			required={required}
			label={formatMessage(labelMsg)}
			help={helpMsg === undefined ? undefined : formatMessage(helpMsg)}
			error={error}
			path={path}
		>
			<UnknownInputRenderer {...(input as InputData)} />
		</Field>
	);
};
